module.exports = __webpack_public_path__ + "img/6-4.911df0fc.png";